import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer, { RootState } from "./allReducers";

const persistConfig = {
  key: "rootData",
  storage,
};

const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer);
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "REGISTER"],
      },
    }),
});

const persistedStore = persistStore(store);

export type AppDispatch = typeof store.dispatch;

export { persistedStore, store };
